import { type SelectFieldProps, SelectField, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

export const DeviceTypeField = (
  props: Pick<SelectFieldProps, "source" | "sortable" | "label">,
) => {
  const { isPending, data } = useGetList(MODULE_NAMES.DEVICE_TYPES);

  return (
    <SelectField
      source={props.source}
      sortable={props.sortable}
      isPending={isPending}
      optionValue="id"
      optionText="name"
      label={props.label}
      choices={data ?? []}
    />
  );
};
